export function stringReduce(
  text: string,
  first: number = 5,
  last: number = 5,
  by: string = "..."
) {
  return [text.substring(0, first), text.substring(text.length - last)].join(
    by
  );
}
